import { STATS } from "@/mocks/guaData";

export default function Hero() {
  const marqueeTexts = [
    "🔥 顶流演唱会门票秒空，主办方回应加场",
    "🍉 地铁让座冲突完整视频曝光，两派吵翻",
    "🧧 大厂年终奖规则调整，员工连夜开会",
    "🐱 宠物猫开冰箱偷鱼成'惯犯'",
    "🤖 AI绘画大赛冠军作品遭质疑，宣布复核",
    "🍜 网红烤冷面凌晨排队，是真香还是营销",
  ];

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-gradient-to-b from-primary-50 via-background-50 to-background-50">
      {/* 装饰圆 */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-100/60"></div>
      <div className="pointer-events-none absolute -left-20 top-40 h-72 w-72 rounded-full bg-primary-100/50"></div>
      <div className="pointer-events-none absolute bottom-0 right-10 h-40 w-40 rounded-full bg-secondary-100/60"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pb-14 pt-16 md:pt-20">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-fire-line text-primary-500"></i>
            今日吃瓜群众围观区 · 前排不迷路
          </span>
          <h1 className="heading-font mt-6 text-4xl leading-tight text-foreground-950 md:text-6xl">
            每日看瓜，<span className="text-primary-500">前排吃瓜</span>看热闹
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-foreground-700 md:text-lg">
            聚合全网最新鲜的瓜田现场、网友神评论与蹲后续进度。热门事件前排围观、
            反转细节不遗漏，看热闹的你，就差这一站。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#guatian"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              去瓜田逛逛
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#gensui"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-7 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 sm:w-auto"
            >
              <i className="ri-refresh-line"></i>
              正在蹲后续
            </a>
          </div>
        </div>

        {/* 数据统计 */}
        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200 bg-background-50/80 px-4 py-4 text-center"
            >
              <div className="heading-font text-3xl text-primary-600">{s.num}</div>
              <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 滚动热点字幕 */}
      <div className="relative border-t border-background-200 bg-background-50/70 py-3">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-background-50 to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-background-50 to-transparent"></div>
        <div className="flex w-max animate-marquee gap-10 pl-6">
          {[...marqueeTexts, ...marqueeTexts].map((t, i) => (
            <span key={i} className="whitespace-nowrap text-sm text-foreground-600">
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}